import {doGetAxios, doPostAxios} from './axios';

export const apiEvent = {
  // activeListEventReward: async (params: any) => {
  //   const url = `product/load-buy/event-reward/active-list`;
  //   return doGetAxios(url);
  // },
  // loadBuyEventReward: async (params: any) => {
  //   const url = `product-program/load-buy/event-reward/8`;
  //   return doGetAxios(url);
  // },
  // checkOverCurrentSessionEventReward: async (params: {
  //   productId: number;
  //   productProgramId: number;
  // }) => {
  //   const url = `product/event-reward/check-over-current-session`;
  //   return doPostAxios(url, params);
  // },
  loadProductDetails: async (params: {id: string | number}) => {
    const url = `product/${params.id}`;
    return doGetAxios(url);
  },
  loadActiveList: async () => {
    const url = `product/load-buy/event-reward/active-list`;
    return doGetAxios(url);
  },
  loadBuy: async (params: {id: number}) => {
    const url = `product-program/load-buy/event-reward/${params.id}`;
    return doGetAxios(url);
  },
  bankSuperVisory: async (params: {productId: string | number}) => {
    const url = `bank/supervisory/load?productProgramId=${params.productId}`;
    return doGetAxios(url);
  },
  checkOverCurrentSession: async (params: {productId: string | number}) => {
    const url = 'product/event-reward/check-over-current-session';
    return doPostAxios(url, params);
  },
  excuseTempVolume: async (params: {
    amount: string | number;
    productId: string | number;
    productProgramId: string | number;
  }) => {
    const url = 'investment/direct/bounty/excuse-temp-volume';
    return doPostAxios(url, params);
  },
  createBuyOrder: async (params: {
    amount: number; // 132123123;
    // beginBuyAutoStartDate?: any;
    closedBankNoteTime: number; // 1637143200000;
    closedBankNoteTimeString: string; //'17:00 17/11/2021';
    closedOrderBookTime: number; // 1637119800000;
    closedOrderBookTimeString: string; // '10:30 17/11/2021';
    createdDate: number; //  1636972631505;
    investmentNumber: string; //'911CL39541';
    isBuyAuto: number; //   0;
    productId: number; // 2;
    productName: string; // 'Quỹ Đầu tư Cổ phiếu FC2 (FFC2)';
    productProgramId: number; //  7;
    productSchemeCode: string; //  'F_FLEX';
    productSchemeIsAutoBuy: boolean; //   false;
    productSchemeNameEn: string; // 'FFlex';
    tradeCode: string; //   'FFC2N003';
    tradingTime: number; //  1636979826947;
    tradingTimeString: string; //   '18/11/2021';
  }) => {
    const url = 'investment/direct/bounty/buy-create';
    return doPostAxios(url, params);
  },
  buyConfirm: (params: {
    expiredDurationInMinutes?: number;
    expiredTime?: number;
    otpTransId?: string;
    time?: number;
    transId?: string;
    otp?: string;
  }) => {
    const url = 'investment/direct/bounty/buy-confirm';
    return doPostAxios(url, params);
  },
  //
  loadWalletBounty: async (params: any) => {
    const url = `load/wallet/bounty`;
    return doGetAxios(url);
  },
  getRegulationEvent: async () => {
    try {
      const url = `news/content/load?code=EVENT_REWARD`;
      return doGetAxios(url);
    } catch (error: any) {
      throw error;
    }
  },
  loadEvidenceBankFile: async () => {
    try {
      const url = `load/evidence/bank/file`;
      return doGetAxios(url);
    } catch (error: any) {
      throw error;
    }
  },
  uploadEvidenceBankFile: async (params: any) => {
    try {
      const url = `upload/evidence/bank/file`;
      return doPostAxios(url, params);
    } catch (error: any) {
      throw error;
    }
  },
};
